var rtl_default = {
  "rtl": "JLTEO",
  "ltr": "Wkk-v"
};
export {
  rtl_default as default
};
//# sourceMappingURL=rtl-scss.js.map
